import { cn } from "~/lib/utils";

export default function CashPaymentIcon({ className }: { className?: string }) {
  return (
    <svg
      className={cn("h-10", className)}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 960 960"
    >
      <g>
        <g>
          <rect
            x="387.5"
            y="181.1"
            transform="matrix(6.722900e-02 -0.9977 0.9977 6.722900e-02 48.3078 950.5419)"
            className="fill-[#35A83F]"
            width="290.1"
            height="536.7"
          />
          <path
            className="fill-[#02873E]"
            d="M791,382.7c-21.9-6.9-38.4-25.4-42.8-47.9L334,306.9c-7.4,21.7-26.1,37.8-48.8,41.7L274.4,510
			c23.9,7.5,41.3,28.8,43.6,54.1l411.6,27.7c5.7-24.7,25.8-43.4,50.5-47.7L791,382.7z"
          />

          <ellipse
            transform="matrix(6.722900e-02 -0.9977 0.9977 6.722900e-02 48.2649 950.5255)"
            className="fill-[#35A83F]"
            cx="532.5"
            cy="449.4"
            rx="113.9"
            ry="113.9"
          />
          <g>
            <path
              className="fill-[#02873E]"
              d="M521.1,530.2l1.3-18.6c-13.1-1.5-25.5-5.8-32.7-10.6l7.4-22.5c7.9,5,19.2,9.9,31.9,10.8
				c11.1,0.8,19.1-3,19.6-10.9c0.5-7.4-5.4-12.5-19.6-18.4c-20.4-8.4-34-19.2-32.8-38.1c1.2-17.2,14.2-29.9,35.4-32.6l1.3-18.6
				l19.2,1.3l-1.2,17.2c13.1,1.5,21.7,4.8,27.9,8.4l-7.2,21.7c-4.9-2.5-13.6-7.6-27.7-8.5c-12.7-0.9-17.2,4.3-17.5,9.8
				c-0.4,6.4,6.1,11,22.3,18.4c22.7,9.8,31.4,21.2,30.2,38.7c-1.2,17.4-14.5,31.4-37.2,33.8l-1.3,19.9L521.1,530.2z"
            />
          </g>
        </g>
        <g>
          <rect
            x="166"
            y="196.3"
            transform="matrix(0.9922 -0.1244 0.1244 0.9922 -39.0886 56.6858)"
            className="fill-[#39B54A]"
            width="536.7"
            height="290.1"
          />
          <path
            className="fill-[#009245]"
            d="M675.3,226.5c-22.8-2.6-42.5-17.6-51.1-38.8l-411.9,51.6c-3.1,22.7-18.4,42.1-39.9,50.3L192.5,450
			c24.9,2.8,46,20.4,53.2,44.7L655,443.4c0.9-25.3,17-47.6,40.5-56.5L675.3,226.5z"
          />

          <ellipse
            transform="matrix(0.9922 -0.1244 0.1244 0.9922 -39.0837 56.6785)"
            className="fill-[#39B54A]"
            cx="434.3"
            cy="341.3"
            rx="113.9"
            ry="113.9"
          />
          <g>
            <path
              className="fill-[#009245]"
              d="M438.5,422.7l-2.3-18.5c-13.1,1-26.2-0.9-34.1-4.2l3-23.5c8.7,3.4,20.7,6.1,33.3,4.5
				c11.1-1.4,18.1-6.6,17.1-14.4c-0.9-7.4-7.7-11.3-22.7-14.3c-21.7-4.4-37.1-12.3-39.4-31.2c-2.1-17.1,8.2-32,28.5-38.7l-2.3-18.5
				l19-2.4l2.1,17.1c13.1-1,22.2,0.6,29,2.9l-2.9,22.7c-5.3-1.5-14.8-4.9-28.8-3.1c-12.6,1.6-16,7.5-15.4,13
				c0.8,6.4,8.1,9.6,25.4,13.8c24.2,5.3,34.8,14.8,37,32.3c2.2,17.3-8.2,33.6-30.1,40.3l2.5,19.8L438.5,422.7z"
            />
          </g>
        </g>
        <g>
          <ellipse
            transform="matrix(0.9148 -0.4039 0.4039 0.9148 -247.5537 225.9889)"
            className="fill-[#FFED6C]"
            cx="411.9"
            cy="699.8"
            rx="96.1"
            ry="96.1"
          />

          <ellipse
            transform="matrix(0.9148 -0.4039 0.4039 0.9148 -247.5537 225.9889)"
            className="fill-[#FFD345]"
            cx="411.9"
            cy="699.8"
            rx="72.3"
            ry="72.3"
          />
          <path
            className="fill-[#FBB03B]"
            d="M353.8,734.5c-16.1-36.5,0.4-79.2,36.9-95.3c22.2-9.8,46.6-7.5,65.9,4c-20.3-16-48.6-20.6-73.9-9.4
			c-36.5,16.1-53,58.8-36.9,95.3c6.3,14.3,16.8,25.5,29.3,33C366.2,754.9,358.8,745.6,353.8,734.5z"
          />
          <g>
            <path
              className="fill-[#FBB03B]"
              d="M431.2,746.8l-4.3-9.8c-7.1,2.7-14.6,3.9-19.5,3.3l-2.2-13.5c5.4,0.5,12.5-0.1,19.2-3
				c5.9-2.6,8.9-6.7,7.1-10.8c-1.7-3.9-6.1-4.9-14.9-4.2c-12.7,1.2-22.5-0.7-27-10.7c-4-9.1-0.8-19.1,9.3-26.1l-4.3-9.8l10.1-4.5
				l4,9.1c7.1-2.7,12.4-3.4,16.5-3.2l2.2,13c-3.2,0.1-9-0.2-16.4,3.1c-6.7,3-7.6,6.8-6.3,9.7c1.5,3.4,6.1,4,16.3,3.4
				c14.2-1.1,21.7,2.4,25.8,11.7c4.1,9.2,1,19.9-10,27.3l4.7,10.5L431.2,746.8z"
            />
          </g>
          <g>
            <path
              className="fill-[#FFED6C]"
              d="M425.1,744.5l-4.3-9.8c-7.1,2.7-14.6,3.9-19.5,3.3l-2.2-13.5c5.4,0.5,12.5-0.1,19.2-3
				c5.9-2.6,8.9-6.7,7.1-10.8c-1.7-3.9-6.1-4.9-14.9-4.2c-12.7,1.2-22.5-0.7-27-10.7c-4-9.1-0.8-19.1,9.3-26.1l-4.3-9.8l10.1-4.5
				l4,9.1c7.1-2.7,12.4-3.4,16.5-3.2l2.2,13c-3.2,0.1-9-0.2-16.4,3.1c-6.7,3-7.6,6.8-6.3,9.7c1.5,3.4,6.1,4,16.3,3.4
				c14.2-1.1,21.7,2.4,25.8,11.7c4.1,9.2,1,19.9-10,27.3l4.7,10.5L425.1,744.5z"
            />
          </g>
        </g>
        <g>
          <circle className="fill-[#FFED6C]" cx="624.3" cy="580.7" r="96.1" />
          <circle className="fill-[#FFD345]" cx="624.3" cy="580.7" r="72.3" />
          <path
            className="fill-[#FBB03B]"
            d="M557.2,588.9c0-39.9,32.4-72.3,72.3-72.3c24.2,0,45.6,12,58.7,30.3c-12.1-22.9-36.2-38.5-63.8-38.5
			c-39.9,0-72.3,32.4-72.3,72.3c0,15.7,5,30.2,13.5,42C560.2,612.7,557.2,601.2,557.2,588.9z"
          />
          <g>
            <path
              className="fill-[#FBB03B]"
              d="M622.9,631.5v-10.7c-7.6-0.3-14.9-2.4-19.2-4.9l3.4-13.2c4.7,2.6,11.4,5,18.8,5c6.4,0,10.8-2.5,10.8-7
				c0-4.3-3.6-7-12-9.8c-12.1-4.1-20.3-9.7-20.3-20.7c0-9.9,7-17.7,19.1-20.1v-10.7h11.1v9.9c7.6,0.3,12.7,1.9,16.4,3.7l-3.3,12.8
				c-2.9-1.2-8.1-3.8-16.3-3.8c-7.3,0-9.7,3.2-9.7,6.3c0,3.7,4,6.1,13.6,9.7c13.4,4.7,18.9,11,18.9,21.1s-7.1,18.6-20.1,20.9v11.5
				H622.9z"
            />
          </g>
          <g>
            <path
              className="fill-[#FFED6C]"
              d="M618.3,626.9v-10.7c-7.6-0.3-14.9-2.4-19.2-4.9l3.4-13.2c4.7,2.6,11.4,5,18.8,5c6.4,0,10.8-2.5,10.8-7
				c0-4.3-3.6-7-12-9.8c-12.1-4.1-20.3-9.7-20.3-20.7c0-9.9,7-17.7,19.1-20.1v-10.7H630v9.9c7.6,0.3,12.7,1.9,16.4,3.7l-3.3,12.8
				c-2.9-1.2-8.1-3.8-16.3-3.8c-7.3,0-9.7,3.2-9.7,6.3c0,3.7,4,6.1,13.6,9.7c13.4,4.7,18.9,11,18.9,21.1s-7.1,18.6-20.1,20.9v11.5
				H618.3z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
